import React from 'react'
import clsx from 'clsx'
import { bindUpdate } from 'wdc-cube-react'
import { styled } from '@mui/material/styles'

import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

import { chipSx } from 'src/utils/views'

import { CATEGORY_ARRAY } from '../tc_types'
import { SelectedNodesScope, ChipScope } from '../tc_scopes'

const ChipRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    flexWrap: 'wrap'
})

const CategoryDot = styled('span')({
    width: 8,
    height: 8,
    flex: '0 0 auto',
    borderRadius: '50%'
})

const hintTooltipSx = {
    backgroundColor: '#171b18',
    border: '1px solid #2d382f',
    borderRadius: '10px',
    padding: '10px 12px',
    fontSize: 12,
    boxShadow: 'var(--shadow-2)'
}

const selectedChipSx = {
    ...chipSx('gray'),
    '& .MuiChip-label': { display: 'flex', alignItems: 'center', gap: '6px', padding: '0 9px' },
    '& .MuiChip-deleteIcon': {
        fontSize: 16,
        color: '#8b948f',
        '&:hover': { color: 'var(--danger)' }
    }
}

// ::

export type GraphAppliedFiltersViewProps = {
    className?: string
    scope: SelectedNodesScope
}

export const SelectedNodesView = function ({ className, scope }: GraphAppliedFiltersViewProps) {
    bindUpdate(React, scope)

    return (
        <ChipRow className={clsx(className)}>
            {scope.companies.length > 0 && scope.companies.map((item) => <ChipView key={item.value} scope={item} />)}
            {scope.partners.length > 0 && scope.partners.map((item) => <ChipView key={item.value} scope={item} />)}
            {scope.people.length > 0 && scope.people.map((item) => <ChipView key={item.value} scope={item} />)}
        </ChipRow>
    )
}

export default SelectedNodesView

// ::

const CATEGORY_COLORS = (function () {
    const colors: string[] = []
    for (const category of CATEGORY_ARRAY) {
        colors[category.index] = category.color
    }
    return colors
})()

export type ChipViewProps = {
    key?: string
    scope: ChipScope
}

function ChipView({ scope }: ChipViewProps) {
    bindUpdate(React, scope)

    const label = (
        <>
            <CategoryDot style={{ backgroundColor: CATEGORY_COLORS[scope.category] }} />
            {scope.label}
        </>
    )

    const chip = <Chip key={scope.value} size="small" label={label} sx={selectedChipSx} onDelete={scope.onDelete} />

    if (scope.hint) {
        const hint = <div dangerouslySetInnerHTML={{ __html: scope.hint }} />
        return (
            <Tooltip title={hint} slotProps={{ tooltip: { sx: hintTooltipSx } }}>
                {chip}
            </Tooltip>
        )
    }

    return chip
}
